import { render } from "./ExpiryRequestDialog.vue?vue&type=template&id=04dc9501&scoped=true"
import script from "./ExpiryRequestDialog.vue?vue&type=script&lang=js"
export * from "./ExpiryRequestDialog.vue?vue&type=script&lang=js"

import "./ExpiryRequestDialog.vue?vue&type=style&index=0&id=04dc9501&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dc9501"]])

export default __exports__